// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"SidePopup_popupContainer__2xcRU","sidePopup":"SidePopup_sidePopup__3HXzS","actionSection":"SidePopup_actionSection__3gT9O"};